import React, { Component } from 'react';
import { TextBox } from 'devextreme-react';
import i18n from '../../i18n';
import PropTypes from 'prop-types';

class BaseReadOnlyConstants extends Component {
    constructor(props) {
        super(props);

        this.CONSTANTS = [];
    }

    render() {
        const { value, i18nLabel, currentLanguageActive } = this.props;

        return (
            <div className={'dx-field'}>
                <div className={'dx-field-label'}>
                    {i18n.t(i18nLabel) + ':'}
                </div>

                <div className={'dx-field-value'}>
                    <TextBox
                        className={'multi-language'}
                        name={'name'}
                        value={JSON.parse(this.CONSTANTS[value].name)[currentLanguageActive]}
                        readOnly={true}
                    />
                </div>
            </div>
        );
    }
}

BaseReadOnlyConstants.propTypes = {
    currentLanguageActive: PropTypes.string,
    i18nLabel: PropTypes.string,
    value: PropTypes.any
};

export default BaseReadOnlyConstants;
